export const courseMaterialBlockClass = "course-material-block"
export const COURSE_MATERIAL_DEFAULT_BLOCK_MARGIN_REM = 3
